import React from 'react';
import cs from 'classnames';
import {connect} from 'react-redux';
import {push as changeURL} from 'react-router-redux';
import css from './index.css';
import Tabs from '../../tabs/tabs';
import CommonCheck from '../common/commonCheck';
import FuelCalculator from '../common/fuelCalculator';
import AddressInformation from '../common/addressInformation';
import mapDispatch from '~/misc/mapDispatch';
import {getRateAverage, getFuelPrice, removeRateCheck} from '~/modules/rate/actions';
import Spinner from '~/components/common/Spinner';

class RateCheck extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 'Rate Check',
      chooseArr: ['Rate Check', 'Fuel Surcharge Calculator'],
      condition: true,
    };
    this.unfoldSelect = this.unfoldSelect.bind(this);
    this.downSelect = this.downSelect.bind(this);
    this.myFunction = this.myFunction.bind(this);
  }
  componentWillMount () {
    // 未登录返回首页
    if (!this.props.user.token) {
      this.props.gotoRoot();
    }
    // 获取油价、loads平均利润值;
    const pickup = this.props.pickup;
    const dropOff = this.props.dropOff;
    const equipment = this.props.equipment;
    this.props.getRateAverage({pickup, dropOff, equipment});
    this.props.getFuelPrice({pickup, dropOff});
    document.addEventListener('click', this.myFunction, false);
  }
  componentWillUnmount(){
    document.removeEventListener('click', this.myFunction, false);
    this.props.removeRateCheck();
  }
  componentWillReceiveProps(nexProps) {
    // 登录返回首页
    if (!nexProps.user.isLoggedIn && !nexProps.user.loading) {
      this.props.gotoRoot();
    }
  }
  myFunction () {
    this.setState({condition: true});
  }
  render () {
    const pick = this.props.pick;
    const drop = this.props.drop;
    const equipment = this.props.equipment;
    const sdRateAverage = this.props.sdRateAverage;
    const fuelPrice = this.props.fuelPrice;
    if (sdRateAverage === 'undefined' || fuelPrice === 'undefined'){
      return (<div className={cs(css.main)}>
          <div className={css.spinnerLine}>
            <div className={css.spinner}>
              <Spinner scalable={true}/>
            </div>
          </div>
      </div>);
    }
    return (
      <div className={cs(css.main)}>
        <AddressInformation pick={pick} drop={drop} equipment={equipment}/>
        <div
            className={cs(css.paging)}
        >
            {this.renderForm()}
        </div>
        <div className={cs(css.adapterPaging)}>
          <div className={cs(css.pagingtitle)}>
            <div className={cs(css.adapterTabs)}>
              <span className={cs(css.menuContent)} onClick={this.unfoldSelect}>{this.state.value}</span>
              <span
                className={cs(this.state.condition ? css.down : css.unfold)}
                onClick={this.unfoldSelect}
              ></span>
              <ul
                className={cs(css.wrapUl)}
                style={{display: this.state.condition ? 'none' : 'block'}}
              >
                {this.state.chooseArr.map(item =>
                  <li
                    className={cs(css.wrapItem)}
                    key={item}
                    value={item}
                    onClick={(event) => {this.downSelect(event, item)}}
                  >{item}</li>
                )}
              </ul>
            </div>
          </div>
          <div className={cs(css.adapterTabsContent)}>
            {
              this.state.value === 'Rate Check' ? this.renderCheck() : this.renderCalculator()
            }
          </div>
        </div>
      </div>
    )
  }
  renderForm () {
    return (
      <div>
        <Tabs
          id='rateCheck'
          tabs={[
            {id: 'check', title: 'Rate Check', dataqa: 'Rate Check'},
            {id: 'calculator', title: 'Fuel Surcharge Calculator', dataqa: 'Fuel Surcharge Calculator'}
          ]}
          csTab={cs(css.tab)}
          csTabs={cs(css.tabs)}
          csTabActive={cs(css.tabActive)}
          content={{
            check: this.renderCheck(),
            calculator: this.renderCalculator()
          }}
        />
      </div>
    )
  }
  renderCheck () {
    return (
      <div className={cs(css.check)}>
        <CommonCheck
          secondaryPages='true'
          distance={this.props.distance}
          targetPrice={this.props.targetPrice}
          sdRateAverage={this.props.sdRateAverage}
          fuelPrice={this.props.fuelPrice}
        />
      </div>
    )
  }
  renderCalculator () {
    return (
      <div className={cs(css.calculator)}>
        <FuelCalculator distance={this.props.distance}/>
      </div>
    )
  }
  unfoldSelect (event) {
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    this.setState({condition: !this.state.condition});
  }
  downSelect (event, k) {
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    this.setState({condition: !this.state.condition, value: k});
  }
}
export default connect (({user, rate}, {location:{query: {param}}, history}) => {
  const data = JSON.parse(param);
  let pickCity = data.pickup.city;
  let pickState = data.pickup.state;
  let dropCity = data.drop_off.city;
  let dropState = data.drop_off.state;
  let pick, drop;
  if (pickCity && pickCity !== 'null' && pickCity !== 'undefined') {
    pick = pickCity + ', ' + pickState;
  } else {
    pick = pickState;
  }
  if (dropCity && dropCity !== 'null' && dropCity !== 'undefined') {
    drop = dropCity + ', ' + dropState;
  } else {
    drop = dropState;
  }
  return {
    user: user,
    pick: pick,
    drop: drop,
    targetPrice: data.target_price ? data.target_price : 0,
    deadhead: data.dho ? data.dho : 200,
    distance: data.distance ? data.distance : undefined,
    equipment: data.equipment.join(","),
    pickup: data.pickup,
    dropOff: data.drop_off,
    sdRateAverage: rate.sdRateAverage,
    fuelPrice: rate.fuelPriceAvg === '--' ? undefined : rate.fuelPriceAvg
  }
}, mapDispatch({
  getRateAverage: (props, data) => getRateAverage(data),
  getFuelPrice: (props, data) => getFuelPrice(data),
  removeRateCheck: (props) => removeRateCheck(),
  gotoRoot: () => changeURL('/'),
}))(RateCheck);



// WEBPACK FOOTER //
// ./src/components/rate/rateCheck/index.js